import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar({ onOpenWaitlist }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => setMenuOpen(prev => !prev);

  const closeMenu = () => setMenuOpen(false);

  const isActive = (path) => location.pathname === path ? 'active' : '';

  return (
    <nav>
      <div className="nav-container">
        <div className="logo-wrap">
          <div className="logo-symbol">
            <Link to="/">
              <img src="/images/logo.png" alt="Chattak logo" className="nav-logo" height="40" width="40"
                onError={e => { e.target.style.display = 'none'; e.target.parentElement.innerText = 'C'; }} />
            </Link>
          </div>
          <Link to="/"><div className="logo-text">Chattak</div></Link>
        </div>

        <div className="nav-links">
          <a href="/#payment-grid">Product</a>
          <a href="/#api">Developers</a>
          <a href="/#use-cases">Use cases</a>
          <Link to="/privacy-policy" className={isActive('/privacy-policy')}>Privacy</Link>
          <Link to="/terms-of-services" className={isActive('/terms-of-services')}>Terms</Link>
          <Link to="/login" className="login-btn">Log in</Link>
        </div>

        <button
          className="mobile-menu-btn"
          aria-label="Open menu"
          aria-expanded={menuOpen}
          onClick={toggleMenu}
        >
          <span></span><span></span><span></span>
        </button>
      </div>

      <div className="mobile-nav" id="mobileNav" style={{ display: menuOpen ? 'flex' : 'none' }}>
        <a href="/#payment-grid" onClick={closeMenu}>Product</a>
        <a href="/#api" onClick={closeMenu}>Developers</a>
        <a href="/#use-cases" onClick={closeMenu}>Use cases</a>
        <Link to="/privacy-policy" onClick={closeMenu}>Privacy</Link>
        <Link to="/terms-of-services" onClick={closeMenu}>Terms</Link>
        <Link to="/login" className="login-btn mobile-login" onClick={closeMenu}>Log in</Link>
      </div>
    </nav>
  );
}
